import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=bae1b2f6&scoped=true"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"
import style0 from "./materialItem.vue?vue&type=style&index=0&id=bae1b2f6&prod&lang=scss&scoped=true"
import style1 from "./materialItem.vue?vue&type=style&index=1&id=bae1b2f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae1b2f6",
  null
  
)

export default component.exports